import { Link, useRouter } from "@/lib/router";
import { Button } from "@/components/ui/button";
import { Trophy, Upload, Search } from "lucide-react";
import { cn } from "@/lib/utils";

export function Navbar() {
	const { path } = useRouter();

	const links = [
		{ to: "/", label: "Browse", icon: Search },
		{ to: "/leaderboard", label: "Makers", icon: Trophy },
		{ to: "/upload", label: "Upload", icon: Upload },
	];

	return (
		<nav className="sticky top-0 z-50 border-b border-border/50 bg-background/80 backdrop-blur-xl">
			<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
				<div className="flex h-16 items-center justify-between">
					<div className="flex items-center gap-1">
						{links.map((link) => {
							const Icon = link.icon;
							const isActive = link.to === "/" ? path === "/" : path.startsWith(link.to);
							return (
								<Link key={link.to} to={link.to}>
									<Button
										variant={isActive ? "secondary" : "ghost"}
										size="sm"
										className={cn(
											"gap-2 text-sm",
											isActive && "bg-secondary font-medium"
										)}
									>
										<Icon className="h-4 w-4" />
										<span className="hidden sm:inline">{link.label}</span>
									</Button>
								</Link>
							);
						})}
					</div>
				</div>
			</div>
		</nav>
	);
}
